


































































































































































































import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import {mapGetters, mapActions} from 'vuex';
import {formMixins} from '@/components/SignUpForm/mixins';
import ConfirmByPhone from '@/components/ConfirmByPhone';
import { AxiosResponse } from 'axios';
import { sendUpdateUserPhoneVerify } from '@/services/api';

@Component({
  name: 'EditPersonalData',
  components: {
    ConfirmByPhone,
  },
  data() {
    return {
      emailErrorMessages: [],
      emailValue: null,
      phoneValue: '',
      actualBirthday: '',
      actualGender: '',
      editField: null,
      editableMob: false,
      emailPopup: false,
      errorMessagePopup: '',
      inputsTexts: ['first_name', 'last_name'],
      newPhone: '',
      openedGenders: false,
      phoneError: [],
      phonePopup: false,
      showDatePicker: false,
      showIcon: null,
      showPopup: false,
      today: new Date().toISOString().substr(0, 10),
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.actualGender = this.loggedUser.gender;
      this.actualBirthday = this.loggedUser.birthday ? this.loggedUser.birthday : this.today;
    });
  },
  computed: {
    ...mapGetters('profile', ['personalData']),
    ...mapGetters('user', ['loggedUser']),
    ...mapGetters(['resendThrottle', 'language']),
    actualEmailValue: {
      get() {
        return this.emailValue ?? this.loggedUser.email;
      },
      set(value) {
        (this as any).emailErrorMessages = [];
        this.emailValue = value;
        return value;
      },
    },
    emailError(): boolean {
      return !!(this as any).emailErrorMessages.length;
    },

    errorFields(): string[] {
      const arr: string[] = [];
      if ((this as any).phoneError.length) {
        arr.push('phone');
      }
      if (!!(this as any).emailErrorMessages.length) {
        arr.push('email');
      }
      return  arr;
    },
  },
  methods: {
    ...mapActions(['showCentralAlert']),
    ...mapActions('user', [
      'uploadUserImg',
      'updateUserData',
      'updateUserEmail',
      'updateUserPhone',
      'updateUserPhoneVerify',
    ]),

    rulesEmailValid() {
      return formMixins.rules.email((this as any).actualEmailValue, {
        at: this.personalData.errorsMessages.emailWrong,
        user: this.personalData.errorsMessages.emailWrong,
        domain: this.personalData.errorsMessages.emailWrong,
        });
    },

    rulesPhoneValid() {
      return formMixins.rules.phone((this as any).phoneValue, this.personalData.errorsMessages.phoneWrong);
    },


    pickFile() {
      (this.$refs.image as HTMLElement).click();
    },

    changeStatusGenders(state) {
      this.openedGenders = state;
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined && this.loggedUser) {
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.uploadUserImg({id: this.loggedUser.id, photo: {photo: fr.result}})
              .catch((error) => console.error(error));
        });
      } else {
        console.error('error on upload photo');
      }
    },

    cancelChanges() {
      this.editField = null;
      this.showIcon = null;
      this.actualGender = this.loggedUser.gender;
    },

    saveActualDate(field, value) {
      field === 'first_name' ||
      field === 'last_name' ||
      field === 'birthday' ||
      field === 'gender' ? this.updateAccount(field, value) :
          field === ('email') ? this.updateAccountEmail(field, value) :
              field === ('phone') ? this.updateAccountPhone(field, value) : (() => false)();
    },

    updateAccount(field, value) {
      if (value) {
        const newData = {
          first_name: this.loggedUser.first_name,
          last_name: this.loggedUser.last_name,
          birthday: this.loggedUser.birthday,
          gender: this.actualGender,
        };
        field !== 'gender' && value !== this.today ? newData[field] = value : (() => false)();
        this.updateUserData({id: this.loggedUser.id, newData})
            .then((response) => {
              this.editField = null;
              this.showIcon = null;
            }).catch((error) => console.error(error));
      }
    },

    updateAccountEmail(field, value) {
      if (this.$refs.email[0].valid && value !== this.loggedUser.email) {
        this.updateUserEmail({email: value})
            .then((response) => {
              if ((response?.status === 400 || response?.status > 401) && (response?.status < 500)) {
                (this as any).emailErrorMessages = response.data?.mobile_errors.map((error) => error.messages)[0];
              } else {
                this.editField = null;
                this.showIcon = null;
                this.showPopup = true;
                this.emailPopup = true;
                this.phonePopup = false;
              }
            }).catch((error) => console.error(error));
      } else if (value === this.loggedUser.email) {
        this.editField = null;
        this.showIcon = null;
      }
    },

    updateAccountPhone(field, value) {
      // delete spaces between numbers +380 500 00 00 -> +3805000000
      value = value.replace(/ /g, '');
      if (this.$refs.phone[0].valid && value !== this.loggedUser.phone) {
        this.newPhone = value;
        this.updateUserPhone({phone: value})
            .then((response: AxiosResponse) => {
              if (response) {
                this.phoneError = response.data.phone;
              } else {
                this.editField = null;
                this.showIcon = null;
                this.showPopup = true;
                this.phonePopup = true;
                this.emailPopup = false;
              }
            }).catch((error) => console.error(error));
      } else if (value === this.loggedUser.phone) {
        this.editField = null;
        this.showIcon = null;
      }
    },

    resendValidateCode() {
      this.updateUserPhone({phone: this.newPhone})
          .then((response) => {
            this.editField = null;
            this.showIcon = null;
            this.showPopup = true;
            this.phonePopup = true;
            this.emailPopup = false;
          }).catch((error) => console.error(error));
    },

    closePopup() {
      this.showPopup = false;
      this.phonePopup = false;
      this.emailPopup = false;
    },

    sendVerifyCode(request) {
      request.id = this.loggedUser.id;
      sendUpdateUserPhoneVerify(request)
        .then((response) => {
          if (response.status === 200) {
            this.closePopup();
          } else if (response.status === 404) {
            this.errorMessagePopup = this.personalData.phone_popup.errorEmptyCode;
            setTimeout(() => this.errorMessagePopup = '', 3000);
          } else if (response.status === 401) {
            this.$router.push({name: 'accounts'});
          } else if (response.status !== 200) {
            this.errorMessagePopup = response.data.errors.sms_code;
            setTimeout(() => this.errorMessagePopup = '', 3000);
          }
        }).catch((error) => console.error(error));
    },

    openEditField(index) {
      this.editField = this.$vuetify.breakpoint.xsOnly && !this.editableMob ? null : index;
      if (index === 3 && this.editableMob) {
        setTimeout(() => {
          const selectBlock = this.$refs.selectBlock[0];
          selectBlock.click();
        }, 100);
      }
    },

    toggleEditMobile() {
      this.editableMob = !this.editableMob;
      this.editField = null;
    },
  },
})
export default class EditPersonalData extends Vue {
}
